import { LOGIN, LOGOUT, SET_USER_ACCOUNTS, SET_USER_ADACCOUNTS, SET_FIREBASE_ACCOUNT } from './mutations-types'
import firebase from 'firebase/app'
import 'firebase/auth'
import firebaseSdk from '../../../firebase/main'
import User from '../../../facebook/User'
import store from '../../store'
import Intercom from '../../../Intercom'
import helpers from '../../../helpers/functions'

export default {
  async login({ state, commit, dispatch }) {
    if (localStorage.getItem('outfoxUser')) {
      let user = JSON.parse(localStorage.getItem('outfoxUser'))
      commit(LOGIN, user)
      return true
    }

    let provider = new firebase.auth.FacebookAuthProvider()
    provider.addScope('ads_management')
    provider.addScope('pages_show_list')
    provider.addScope('publish_video')
    // Note: Signin with facebook account

    const fbUser = await firebase.auth().signInWithPopup(provider)

    let user = {
      profile: fbUser.additionalUserInfo.profile,
      name: fbUser.user.displayName,
      email: fbUser.user.email,
      avatar: fbUser.user.photoURL,
      token: fbUser.credential.accessToken
    }
    let facebook = new User({ id: fbUser.additionalUserInfo.profile.id, token: fbUser.credential.accessToken })

    // Note: get ad accounts
    const adAccounts = await facebook.getAdAccounts()
    user.adAccounts = Array.isArray(adAccounts) ? adAccounts : []
    store.commit(SET_USER_ADACCOUNTS, adAccounts)

    // Note: get accounts
    const accounts = await facebook.getAccounts()
    user.accounts = Array.isArray(accounts) ? accounts : []
    store.commit(SET_USER_ACCOUNTS, accounts)

    // Note: check firebase DB is user exists
    const existingUser = await firebaseSdk.Users.getUserByFacebookId(user.profile.id)

    // Note: if exists, continue with current user
    if (existingUser) {
      commit(SET_FIREBASE_ACCOUNT, existingUser)
      user.firebaseAccount = existingUser
      localStorage.setItem('outfoxUser', JSON.stringify(user))
      commit(LOGIN, user)
      return true
    }

    // Note: otherwise create new user
    const payload = {
      name: user.name,
      email: user.email,
      facebook_id: user.profile.id,
      facebookAccessToken: fbUser.credential.accessToken
    }
    const newUser = await firebaseSdk.Users.createUser(payload)

    commit(SET_FIREBASE_ACCOUNT, Object.assign(payload, { id: newUser.id }))
    user.firebaseAccount = Object.assign(payload, { id: newUser.id })
    localStorage.setItem('outfoxUser', JSON.stringify(user))
    commit(LOGIN, user)
    dispatch('stopSpinner')
    return false
  },
  logout({ commit, dispatch }) {
    firebase
      .auth()
      .signOut()
      .then(() => {
        localStorage.removeItem('outfoxUser')
        commit(LOGOUT)
        let notification = {
          type: 'success',
          message: [`<div>You're now logged out</div>`]
        }
        dispatch('showNotification', notification)
        dispatch('clearState')
        const intercom = new Intercom()
        intercom.destroy()
      })
      .catch(err => helpers.handleError(err))
  },
  updateUser({ commit, dispatch }, payload) {
    let user = JSON.parse(localStorage.getItem('outfoxUser'))
    user.firebaseAccount = payload
    localStorage.setItem('outfoxUser', JSON.stringify(user))
    return new Promise(resolve => {
      resolve(firebaseSdk.Users.updateUser(payload))
    })
      .then(() => {
        dispatch('clearState')
        dispatch('fetchApiData')
        commit(SET_FIREBASE_ACCOUNT, payload)
        return true
      })
      .catch(err => helpers.handleError(err))
  }
}
